// Legal disclosure shown after "© {year}" in every site footer (main, Global, USA, donation pages).
export const FOOTER_LEGAL_LINE =
  "Nivaran Foundation Inc. (USA) · EIN 41-2656587 · Programs in Nepal delivered by Nivaran Foundation, Kathmandu · Company Reg. No. 359535/81/82 · Social Welfare Council Affiliation No. 57727";
